var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]},[_c('div',{staticClass:"fullview"},[_c('div',{staticClass:"loading-spacer"}),_c('vue-loading',{attrs:{"type":"bars","color":"#7E6990","size":{ width: '150px', height: '150px' }}}),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }